import { useChatStatus } from "@core/features/chat";
import type { Circle } from "@core/types/core.types";
import { useTalkJSData } from "./useChat";

export type UseChatStatusWithCirclesArgs = {
  /** User's circles for access control */
  userCircles: Circle[] | null | undefined;
};

/**
 * Platform-specific wrapper for useChatStatus.
 * Automatically wires up TalkJS data from React Query.
 *
 * @example
 * ```typescript
 * const userCircles = usePlatformStore((s) => s.userCircles);
 * const { isChatEnabled, isLoading } = useChatStatusWithCircles({ userCircles });
 * ```
 */
export function useChatStatusWithCircles({
  userCircles,
}: UseChatStatusWithCirclesArgs) {
  const talkjsData = useTalkJSData();

  return useChatStatus({ talkjsData, userCircles });
}

